import React from 'react';
import { Box, Container, Typography, Card, CardContent, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function Pricing() {
  const includedInBoth = [
    'Konto och säker inloggning',
    'Din egen loggbok',
    'Möjlighet att redigera och ta bort egna loggar',
  ];

  const basFeatures = [
    '10 tripploggar',
    '10 serviceloggar',
    'Kostnadsfritt – följer automatiskt med när du skapar konto',
  ];

  const premiumFeatures = [
    'Obegränsat antal tripploggar',
    'Obegränsat antal serviceloggar',
    'Bjud in andra användare till loggboken – de kan läsa och bidra med innehåll',
    '39 kr per månad eller 390 kr per år',
  ];

  const renderList = (items) => (
    <List dense disablePadding>
      {items.map((item, index) => (
        <ListItem key={index} disableGutters sx={{ py: 0.25 }}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <CheckCircleOutlineIcon sx={{ color: '#1A237E', fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary={item} primaryTypographyProps={{ variant: 'body2', color: '#212121' }} />
        </ListItem>
      ))}
    </List>
  );

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px - 120px)',
        backgroundColor: '#F5F9FF',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2rem', md: '2.5rem' },
              fontWeight: 700,
              color: '#1A237E',
              mb: 2,
            }}
          >
            Priser
          </Typography>
          <Typography variant="body1" sx={{ color: '#212121', maxWidth: 560, mx: 'auto' }}>
            När du skapar ett konto får du automatiskt den kostnadsfria basplanen. Du kan uppgradera till Premium när du vill ha obegränsat med loggar och fler funktioner.
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: 3,
            mb: 6,
          }}
        >
          <Card
            elevation={0}
            sx={{
              border: '1px solid',
              borderColor: '#1A237E',
              borderRadius: 2,
              backgroundColor: '#fff',
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1 }}>
                Bas
              </Typography>
              <Typography variant="h5" sx={{ color: '#212121', fontWeight: 700, mb: 2 }}>
                Gratis
              </Typography>
              <Typography variant="body2" sx={{ color: '#212121', mb: 2 }}>
                Det som ingår i båda planerna:
              </Typography>
              {renderList(includedInBoth)}
              <Typography variant="body2" sx={{ color: '#212121', mt: 2, mb: 1 }}>
                I basplanen ingår dessutom:
              </Typography>
              {renderList(basFeatures)}
            </CardContent>
          </Card>

          <Card
            elevation={0}
            sx={{
              border: '1px solid',
              borderColor: '#1A237E',
              borderRadius: 2,
              backgroundColor: '#fff',
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1 }}>
                Premium
              </Typography>
              <Typography variant="h5" sx={{ color: '#212121', fontWeight: 700, mb: 2 }}>
                39 kr/månad eller 390 kr/år
              </Typography>
              <Typography variant="body2" sx={{ color: '#212121', mb: 2 }}>
                Det som ingår i båda planerna:
              </Typography>
              {renderList(includedInBoth)}
              <Typography variant="body2" sx={{ color: '#212121', mt: 2, mb: 1 }}>
                I Premium ingår dessutom:
              </Typography>
              {renderList(premiumFeatures)}
            </CardContent>
          </Card>
        </Box>

        <Card
          elevation={0}
          sx={{
            border: '1px solid',
            borderColor: '#B0BEC5',
            borderRadius: 2,
            backgroundColor: '#fff',
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Typography
              variant="h6"
              component="h2"
              sx={{ color: '#1A237E', fontWeight: 600, mb: 2 }}
            >
              Vanliga frågor
            </Typography>

            <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 600, mt: 2, mb: 0.5 }}>
              Kan jag byta plan när som helst?
            </Typography>
            <Typography variant="body2" sx={{ color: '#212121', mb: 1 }}>
              Ja. Du kan uppgradera till Premium när du vill. Vid uppsägning av Premium återgår du till basplanen vid nästa faktureringsdatum.
            </Typography>

            <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 600, mt: 2, mb: 0.5 }}>
              Vad händer med mina loggar om jag säger upp Premium?
            </Typography>
            <Typography variant="body2" sx={{ color: '#212121', mb: 1 }}>
              Kontot återgår till basplanen med max 10 tripploggar och 10 serviceloggar. Om du har fler loggar än så har du 30 dagar på dig att skapa PDF-filer av innehållet. Därefter kommer överskjutande innehåll att tas bort. Du får information om detta i samband med uppsägningen.
            </Typography>

            <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 600, mt: 2, mb: 0.5 }}>
              Hur säger jag upp prenumerationen?
            </Typography>
            <Typography variant="body2" sx={{ color: '#212121' }}>
              Du kan säga upp Premium när som helst från din kontosida under prenumeration. Prenumerationen löper ut vid nästa faktureringsdatum och du behåller tillgång till Premium till dess.
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}

export default Pricing;
